export default "__VITE_ASSET__BanBxiid__"